import { render, staticRenderFns } from "./Mensagenslua.vue?vue&type=template&id=3c060660"
import script from "./Mensagenslua.vue?vue&type=script&lang=js"
export * from "./Mensagenslua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports